import en from './en';
import pl from './pl';

export const resources = {
  en,
  pl,
};

export default resources;
